/*
	validator.js is used to validate all fields in any forms
	https://validatejs.org/#validators for all validations.
*/
export const fieldNames = {
  disapprovalReason: 'disapprovalReason',
};

export default {
  [fieldNames.disapprovalReason]: {
    presence: true,
  },
};



// WEBPACK FOOTER //
// ./src/ui/admin/claims/AdminClaimDisapproveModal/model.js